<template>
  <div class="d-flex">
    <div class="d-flex flex-column align-items-center badge-wrapper">
      <div class="icon-wrapper flex-center">
        <svg-sprite-icon :id="award.icon" class="award-badge" />
      </div>
      <div class="caption mt-1 text-mini text-center text-gradient text-uppercase">
        {{ award.caption }}
      </div>
    </div>
    <i class="caret-heavy-right-icon mx-3 mt-2"></i>
    <div class="mt-1">
      <div class="d-flex flex-wrap">
        <div
          class="d-flex align-items-center awardee"
          v-for="recipientId in award.recipientIds"
          :key="recipientId"
        >
          <user-short :user-id="recipientId" length="22" />
          <span
            class="bold ml-2 text-small-1"
            :class="{ 'current-user': user.id == recipientId }"
            v-no-capture
            >{{ userNameById(recipientId) }}</span
          >
        </div>
      </div>
      <component :is="clampNote ? 'height-limiter' : 'div'" label="Show full note">
        <component :is="preventImageViewer ? 'div' : 'with-gallery'">
          <div
            class="mt-1 text-prime note text-small-1"
            v-html="note"
            :class="{ 'clamp-note': clampNote }"
          ></div>
        </component>
      </component>
    </div>
  </div>
</template>

<script>
import UserShort from '@/components/UserShort'
import SvgSpriteIcon from '@/components/SvgSpriteIcon'
import WithGallery from '@/components/WithGallery'
import convertHTMLToPlainText from '@/utils/convertHTMLToPlainText'
import formatFreeText from '@/utils/formatFreeText'
import HeightLimiter from '@/components/HeightLimiter'

/**
 * This component renders meta information (badge, caption and note) of the award
 */
export default {
  name: 'AwardMeta',
  components: {
    UserShort,
    SvgSpriteIcon,
    HeightLimiter,
    WithGallery
  },
  props: ['award', 'orgId', 'showNoteAs', 'clampNote', 'preventImageViewer'],
  computed: {
    note() {
      return this.showNoteAs === 'plain'
        ? convertHTMLToPlainText(this.award.note)
        : formatFreeText(this.orgId, this.award.note)
    },
    user() {
      return this.$store.getters.user
    }
  },
  methods: {
    userNameById(id) {
      const user = this.$store.getters.userById(id)
      return user?.displayName
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.icon-wrapper {
  @include dimension(50px, 50px);
  background-color: $selectionColor;
  border-radius: 50%;
}

.award-badge {
  @include dimension(30px, 30px);
}

.caption {
  font-weight: 700;
}

.awardee:not(:last-child) {
  margin-right: 16px;
}

.awardee {
  margin-bottom: 5px;
}

.note {
  padding-top: 2px;
}

.clamp-note {
  @include lineClamp(2);
}

.current-user {
  color: $active;
}

.badge-wrapper {
  width: 90px;
}
</style>
